// E2E-J8-06: Radix gives focus back only to a DialogTrigger, so a dialog opened from code (a button's onClick, a
// menu item, a link with state) left keyboard and screen reader users on <body> when it closed (WCAG 2.4.3).
// Remember what had focus when the dialog opened and give it back on close, unless the caller's own handler
// already took care of focus (it calls event.preventDefault()).
import { useRef } from 'react'

type AutoFocusHandler = ((event: Event) => void) | undefined

export function useReturnFocusToOpener(onOpenAutoFocus?: AutoFocusHandler, onCloseAutoFocus?: AutoFocusHandler) {
  const opener = useRef<Element | null>(null)
  return {
    onOpenAutoFocus: (event: Event) => {
      opener.current = typeof document === 'undefined' ? null : document.activeElement
      onOpenAutoFocus?.(event)
    },
    onCloseAutoFocus: (event: Event) => {
      onCloseAutoFocus?.(event)
      if (event.defaultPrevented) return
      const el = opener.current
      opener.current = null
      if (el instanceof HTMLElement && el !== document.body && el.isConnected) {
        event.preventDefault()
        el.focus({ preventScroll: true })
      }
    },
  }
}
